module.exports = __webpack_public_path__ + "static/landingpagebg-ec379c7efa8f84d5301dddb170a375bf.svg";